module.exports = __webpack_public_path__ + "img/img_v_1.46175c12.jpg";